import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UtilService, BriefingService } from '../services';
import { FormGroup } from '@angular/forms';
import { map, takeUntil, first } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as moment from "moment";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'briefing-schedule-editor',
    template: `
        <div *ngIf="briefingId" fxLayout="row" style="background-color: #FFFFFF">
            <span fxFlex></span>
            <button mat-button 
                    color="primary" 
                    style="margin-top: 15px; margin-right: 15px;"
                    (click)="sendNow()" 
                    [disabled]="form.invalid">Send Now</button>
        </div>
        <div [formGroup]="form" style="padding: 20px;" fxLayout="column" fxLayoutAlign="space-evenly">
            <div>
                <mat-form-field>
                    <mat-select placeholder="Schedule Mode" formControlName="scheduleMode">
                        <mat-option value="RECURRING">Recurring</mat-option>
                        <mat-option value="MANUAL">Manual</mat-option>
                    </mat-select>
                </mat-form-field> 
            </div>
            <div *ngIf="form.get('scheduleMode').value === 'RECURRING'" style="margin-bottom: 10px;">
                <mat-form-field>
                    <mat-select placeholder="Frequency" formControlName="freq">
                        <mat-option *ngFor="let freq of frequencies" [value]="freq.value">{{ freq.viewValue }}</mat-option>
                    </mat-select>
                </mat-form-field>
                <day-picker *ngIf="form.get('freq').value === 'WEEKLY'" formControlName="byday" placeholder="Send Days" fxFlexOffset="20px"></day-picker>
            </div>
            <div *ngIf="form.get('scheduleMode').value === 'RECURRING'" >
                <mat-form-field>
                    <input matInput type=""placeholder="Start Date" formControlName="start" [matDatepicker]="datepicker">
                    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                    <mat-datepicker #datepicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field fxFlexOffset="20px">
                    <mat-select placeholder="Timezone" formControlName="timeZone">
                        <mat-option *ngFor="let zone of timezones" [value]="zone.value">{{ zone.viewValue }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div *ngIf="form.get('scheduleMode').value === 'RECURRING'" style="padding-top: 15px;">
                <div fxLayout="column">
                    <div class="mat-select-placeholder mat-floating-placeholder" style="width: 99px; color: rgba(0, 0, 0, 0.38);">Send Time </div>
                    <time-picker formControlName="sendTime"></time-picker>
                </div>
            </div>               
        </div>
    `
})
export class BriefingScheduleEditorComponent implements OnInit, OnDestroy {
    @Input() form: FormGroup;
    @Input() briefingId: string; 
    cleanupTime$ = new Subject<void>();
    frequencies = this.utilService.digestFrequencies;
    timezones = this.utilService.displayTimezones;

    constructor(private snackBar: MatSnackBar,
                private briefingService: BriefingService, 
                private utilService: UtilService) {}

    ngOnInit(): void {
        this.form.get('freq').valueChanges.pipe(map(freq => freq === 'WEEKLY'), takeUntil(this.cleanupTime$))
        .subscribe(enabled => this.toggleBydayEnabled(enabled));

        this.form.get('sendTime').valueChanges.pipe(map(sendTime => moment(sendTime)), takeUntil(this.cleanupTime$))
        .subscribe(sendTimeMoment => {
            this.form.get('sendHour').setValue(sendTimeMoment.get('hour'));
            this.form.get('sendMinute').setValue(sendTimeMoment.get('minute'));
        });
    }

    toggleBydayEnabled(isEnabled: boolean){
        isEnabled ? this.form.get('byday').enable() : this.form.get('byday').disable();
    }

    sendNow() {
        this.briefingService.sendNow(this.briefingId).pipe(first())
        .subscribe(() => {
            this.briefingService.briefingHistoryChanged.next(this.briefingId);
            this.snackBar.open('Briefing Sent.', 'OK', { duration: 3000});
        });
    }

    ngOnDestroy(): void {
        this.cleanupTime$.next();
        this.cleanupTime$.complete();
    }
}